<template>
  <div class="container">
    <div class="block">
      <!-- <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.push({ name: 'StudioManagerEntry' })"
            >工作室管理</em
          >
          <label><i class="el-icon-arrow-right"></i> 加入退出申请</label>
        </div>
      </div> -->
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">申请类型</span>
          <span class="btnGroup">
            <!-- <el-radio v-model="radio2" label="0" border size="medium">
              全部</el-radio
            > -->
            <el-radio v-model="radio2" label="1" border size="medium">
              加入</el-radio
            >
            <el-radio v-model="radio2" label="2" border size="medium">
              退出</el-radio
            >
          </span>
        </div>
        <div class="myTable-wrap" v-loading="tableLoading">
          <el-table :data="membersList" stripe v-if="radio2 == '1'">
            <el-table-column
              align="center"
              prop="name"
              label="昵称"
              class-name="tb-name"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="uin"
              label="迷你号"
              class-name="tb-uin"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="creator_level"
              label="创作者等级"
              class-name="tb-creatorLevel"
              v-if="userBle"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="creator_level"
              label="开发者等级"
              class-name="tb-creatorLevel"
              v-else
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="op_time"
              label="申请时间"
              class-name="tb-opTime"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.timeStr }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="audit_time"
              label="审核时间"
              class-name="tb-auditTime"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.audit_time }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="op_time"
              label="剩余处理时间"
              class-name="tb-deadTime"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.state == 1">{{
                  scope.row.op_time | remainDay
                }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="map_count"
              label="公开作品"
              class-name="tb-mapCount"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="op"
              label="申请类型"
              class-name="tb-op"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.op | requestType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="options"
              label="操作"
              class-name="tb-options"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.state == 4">已撤销</span>
                <span v-else-if="scope.row.state == 3">已拒绝</span>
                <span v-else-if="scope.row.state == 2">已通过</span>
                <span v-else>
                  <el-button type="text" @click="acceptClicked(scope.row)">
                    通过</el-button
                  >
                  |
                  <el-button type="text" @click="rejectClicked(scope.row)">
                    拒绝</el-button
                  >
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="membersList" stripe v-else>
            <el-table-column
              align="center"
              prop="name"
              label="昵称"
              class-name="tb-name"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="uin"
              label="迷你号"
              class-name="tb-uin"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="timeStr"
              label="退出时间"
              class-name="tb-opTime"
            >
              <!-- <template slot-scope="scope">
                <span>{{ scope.row.uin }}</span>
              </template> -->
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pagination.page_size"
            :current-page="pagination.page"
            :total="total_count"
            @current-change="pageChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getStudioRequest, studioRequestAudit } from '@/api/studio';
import { ONE_DAY, ONE_HOUR } from '../../CONST';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      tableLoading: false,
      radio2: '1',
      total_count: 1,
      pagination: {
        page: 1,
        page_size: 10,
      },
      membersList: [],
      membersData: [],
      userBle: false,
    };
  },
  created() {
    this.total_count = this.$route.params.join_quit_count || 0;
    this.getList();
    this.$emit('update');
    //加入退出申请页曝光埋点
    this.$log('join_quit_apply_show', 85446, { v7: 1 });
    //判断是否427版本
    let version = '';
    //判断是否是427版本
    if (this.userInfo.ver) {
      let ver = this.userInfo.ver.split('.');
      version =
        (parseInt(ver[0]) << 16) + (parseInt(ver[1]) << 8) + parseInt(ver[2]);
      if (version >= 68608) {
        this.userBle = false;
      } else {
        this.userBle = false;
      }
    }
  },
  watch: {
    radio2: function (newVal) {
      console.log('newVal', newVal);
      switch (newVal) {
        // case '0':
        //   this.membersData = this.allList;
        //   break;
        case '1':
          this.membersData = this.joinList;
          break;
        case '2':
          this.membersData = this.quitList;
          break;
      }
      this.total_count = this.membersData.length;
      this.pageChange(1);
    },
  },
  computed: {
    // allList: function () {
    //   return JSON.parse(sessionStorage.getItem('allList') || '[]');
    // },
    allList: function () {
      return JSON.parse(sessionStorage.getItem('allList') || '[]').filter(
        val => val.op != 7,
      );
    },
    joinList: function () {
      return JSON.parse(sessionStorage.getItem('allList') || '[]').filter(
        val => val.op != 7,
      );
    },
    quitList: function () {
      return JSON.parse(sessionStorage.getItem('allList') || '[]').filter(
        val => val.op == 7,
      );
    },
    ...mapState(['developerInfo', 'userInfo']),
  },
  filters: {
    remainDay(op_time) {
      let day = Math.floor(7 - (Date.now() - op_time * 1000) / ONE_DAY);
      let hour = Math.floor(
        ((7 * ONE_DAY - Date.now() + op_time * 1000) % ONE_DAY) / ONE_HOUR,
      );
      return (day > 0 ? day : 0) + ' 天 ' + hour + ' 时';
    },
    requestType(op) {
      return op == 5 || op == 4 ? '加入' : '退出';
    },
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getStudioRequest({ json: 1 }).then(res => {
        this.tableLoading = false;
        res.data.forEach(val => {
          val.timeStr = this.formatTime(val.op_time);
          val.audit_time = this.formatTime(val.audit_time, 1);
        });
        this.membersData = res.data;
        this.total_count = res.data.length;
        this.initPageChange(1); //初始化列表
        sessionStorage.setItem('allList', JSON.stringify(res.data));
      });
    },
    pageChange(currPage) {
      this.pagination.page = currPage;
      let { page, page_size } = this.pagination;
      this.membersList = this.membersData.slice(
        (page - 1) * page_size,
        page * page_size,
      );
    },
    //初始化数组
    initPageChange(currPage) {
      this.pagination.page = currPage;
      let { page, page_size } = this.pagination;
      this.membersData = this.membersData.filter(val => val.op != 7);
      this.membersList = this.membersData.slice(
        (page - 1) * page_size,
        page * page_size,
      );
    },
    formatTime(time, audit) {
      if (audit && time === 0) return '未审核';
      let t = new Date(time * 1000);
      return (
        t.getFullYear() +
        '-' +
        (101 + t.getMonth() + '').slice(-2) +
        '-' +
        (100 + t.getDate() + '').slice(-2)
      );
    },
    acceptClicked(info) {
      let { op, uin } = info;
      studioRequestAudit({ op, member_uin: uin, json: 1, accept: 1 })
        .then(() => {
          this.$message.success('操作成功');
          this.getList();
          this.$emit('update');
        })
        .catch(e => {
          console.log('studioRequestAudit accept err ---', e);
          this.getList();
          this.$emit('update');
        });
    },
    rejectClicked(info) {
      console.log('rejectClicked', info);
      let { op, uin } = info;
      studioRequestAudit({ op, member_uin: uin, json: 1, accept: 0 })
        .then(() => {
          this.$message.success('操作成功');
          this.getList();
          this.$emit('update');
        })
        .catch(e => {
          console.log('studioRequestAudit reject err ---', e);
          this.getList();
          this.$emit('update');
        });
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .block {
    padding: 0;
  }
}
</style>
